import { initNewsletter } from 'components/newsletter'

initNewsletter()
